// === Update following variables to show/hide notification modal
const showNotificationModal = false; // If notification modal is to be shown
const notificationEndTime = new Date("2026-01-09T21:00:00.000Z"); // Notification modal end time (UTC)
const isNotificationModalMaintenance = true; // If notification modal is for maintenance
const notificationModalHeading = "";
const notificationModalDescription = "";

// export const maintenanceStartTime: Date | null = null; // Maintenance start time (UTC)
export const maintenanceStartTime = new Date("2026-01-09T21:00:00.000Z"); // Maintenance start time (UTC)
export const maintenanceDuration = 5; // Maintenance duration in hours

export const notificationModalBlacklist = [
  '/subscribe/plan'
];

// === Helper functions
export const isNotificationModalHidden = () => {
  if (showNotificationModal) {
    const end = new Date(notificationEndTime);
    const endTime = end.getTime();
    const now = Date.now();

    if (now <= endTime) {
      return false;
    }
  }

  return true;
};

export const getNotificationModalHeading = (translateFunc?: any) => {
  if (notificationModalHeading) {
    return notificationModalHeading;
  }

  if (isNotificationModalMaintenance && translateFunc) {
    return translateFunc("notificationModal.maintenanceHeading");
  }

  return "";
};

export const getNotificationModalDescription = (
  translateFunc?: any,
  timezone?: string
) => {
  if (notificationModalDescription) {
    return notificationModalDescription;
  }

  if (isNotificationModalMaintenance && translateFunc) {
    if (!maintenanceStartTime) return "";

    return translateFunc(
      "notificationModal.maintenanceDescription",
      {
        date: new Date(maintenanceStartTime).toLocaleDateString("en-US", {
          timeZone: timezone ?? "America/Toronto",
          year: "numeric",
          month: "long",
          day: "2-digit",
        }),
        time: new Date(maintenanceStartTime).toLocaleTimeString("en-US", {
          timeZone: timezone ?? "America/Toronto",
          timeZoneName: "short",
          hour: "2-digit",
          minute: "2-digit",
        }),
        duration: maintenanceDuration,
      }
    );
  }

  return "";
};
